// LAI's product widget uses srcdoc: add scoped heading styles to that document,
// since theme styles cannot cross the iframe boundary.
if (!customElements.get('product-review-heading')) {
  customElements.define('product-review-heading', class extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      this.breakpoint = window.matchMedia('(min-width: 750px)');
      this.breakpoint.addEventListener('change', this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['srcdoc'],
      });
      this.refresh();
    }

    disconnectedCallback() {
      this.observer.disconnect();
      this.breakpoint.removeEventListener('change', this.refresh);
    }

    refresh() {
      const reference = this.querySelector('[data-heading-style]');
      if (!reference) return;
      const typography = getComputedStyle(reference);
      const properties = ['font-family', 'font-size', 'font-weight', 'font-style',
        'line-height', 'letter-spacing', 'color', 'word-break'];
      const style = `<style id="product-review-heading-style">
        body.product-page {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }
        .header-container h2 {
          ${properties.map(property => `${property}: ${typography.getPropertyValue(property)} !important;`).join('\n')}
          text-align: left !important;
        }
        .header-container, .header-container .left-component {
          text-align: left !important;
        }
      </style>`;

      this.querySelectorAll('iframe.scm-reviews-importer-iframe.main-widget-product').forEach(frame => {
        const source = frame.getAttribute('srcdoc');
        if (!source || !source.includes('</head>')) return;
        const previousStyle = /<style id="product-review-heading-style">[\s\S]*?<\/style>/;
        const updated = previousStyle.test(source)
          ? source.replace(previousStyle, () => style)
          : source.replace('</head>', () => `${style}</head>`);
        // Updating srcdoc reloads the widget, so only do it when its styles differ.
        if (updated !== source) frame.setAttribute('srcdoc', updated);
      });
    }
  });
}
